import { render, staticRenderFns } from "./ConversationV2.vue?vue&type=template&id=01ca1b9c&scoped=true&"
import script from "./ConversationV2.vue?vue&type=script&lang=js&"
export * from "./ConversationV2.vue?vue&type=script&lang=js&"
import style0 from "./ConversationV2.vue?vue&type=style&index=0&id=01ca1b9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ca1b9c",
  null
  
)

export default component.exports